import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import GppMaybeIcon from '@mui/icons-material/GppMaybe'
import { useTranslation } from 'react-i18next'

export default function SubscribePlaceholder() {
  const { t } = useTranslation()
  return (
    <Stack alignItems="center" justifyContent="center" spacing={1} width="100%" height="100%">
      <GppMaybeIcon fontSize="large" />
      <Typography variant="h1" fontSize="30px" fontWeight={700} alignItems="center">
        {t('page.subscribe.title')}
      </Typography>
      {t('page.subscribe.description', { joinArrays: '\n' })
        .split('\n')
        .map((text, index) => {
          return (
            <Typography
              key={index}
              variant="caption"
              sx={[
                {
                  color: (theme) => theme.palette.common.black,
                  fontSize: '14px',
                },
              ]}
            >
              {text}
            </Typography>
          )
        })}
      <Typography variant="caption" fontSize="16px">
        <a href={'mailto:support.medconnect@promotal.com?subject=My Account does not have a subscritpion'}>{t('page.subscribe.email')}</a>
      </Typography>
    </Stack>
  )
}
